import React, { FunctionComponent } from 'react';
import Typography from '@mui/material/Typography';
import { SvgIconProps } from '@mui/material/SvgIcon';
import { Variant } from '@mui/material/styles/createTypography';
import TwitterIcon from '@mui/icons-material/Twitter';
import YouTubeIcon from '@mui/icons-material/YouTube';
import GitHubIcon from '@mui/icons-material/GitHub';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import FacebookIcon from '@mui/icons-material/Facebook';
import InstagramIcon from '@mui/icons-material/Instagram';
import TelegramIcon from '@mui/icons-material/Telegram';
import WebsiteIcon from '@mui/icons-material/Language';
import RedditIcon from '@mui/icons-material/Reddit';
import { DiscordIcon } from '../icons/DiscordIcon';
import { TwitchIcon } from '../icons/TwitchIcon';
import { MediumIcon } from '../icons/MediumIcon';
import { TikTokIcon } from '../icons/TikTokIcon';
import { BlumintIcon } from '../icons/BlumintIcon';
import {
  GradientIconButton,
  GradientIconButtonProps,
} from '../gradients/GradientIconButton';
import { Social, SocialName } from 'functions/src/types/Social';

export type Size = 'small' | 'medium' | 'large';

export type SocialIconProps = {
  social: Social;
  typographyVariant?: Variant;
} & Omit<GradientIconButtonProps, 'IconComponent'>;

export function SocialIcon({
  social,
  typographyVariant,
  ...gradientIconButtonProps
}: SocialIconProps) {
  if (!social) return null;

  const socialIconMap: {
    [social in SocialName]: FunctionComponent<SvgIconProps>;
  } = {
    discord: DiscordIcon,
    twitter: TwitterIcon,
    telegram: TelegramIcon,
    linkedin: LinkedInIcon,
    facebook: FacebookIcon,
    instagram: InstagramIcon,
    github: GitHubIcon,
    youtube: YouTubeIcon,
    blumint: BlumintIcon,
    twitch: TwitchIcon,
    tiktok: TikTokIcon,
    medium: MediumIcon,
    website: WebsiteIcon,
    reddit: RedditIcon,
  };

  const SpecificIcon = socialIconMap[`${social.name}`];
  return (
    <>
      {!!typographyVariant ? (
        <Typography variant={typographyVariant} lineHeight={0}>
          <GradientIconButton
            IconComponent={SpecificIcon}
            size="large"
            {...gradientIconButtonProps}
          />
        </Typography>
      ) : (
        <GradientIconButton
          IconComponent={SpecificIcon}
          {...gradientIconButtonProps}
        />
      )}
    </>
  );
}
